import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsUpdateRequest } from "../services/index";

const API_URL = "/api/timeAdjustment"; // Matches your backend route in server.ts

// Fetch Time Adjustments
export const fetchTimeAdjustments = createAsyncThunk("timeAdjustments/fetch", async () => {
  const response = await hrmsGetRequest(API_URL);
  console.log("API Response:", response.data);
  return response.data;
});

// Update Time Adjustment Status
export const updateTimeAdjustmentStatus = createAsyncThunk(
  "timeAdjustments/updateStatus",
  async ({ id, newStatus }) => {
    const response = await hrmsUpdateRequest(`${API_URL}/${id}/hr-status`, { hrStatus: newStatus });
    return response.data;
  }
);

const timeAdjustmentSlice = createSlice({
  name: "timeAdjustments",
  initialState: {
    adjustments: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTimeAdjustments.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchTimeAdjustments.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.adjustments = action.payload;
      })
      .addCase(fetchTimeAdjustments.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(updateTimeAdjustmentStatus.fulfilled, (state, action) => {
        const index = state.adjustments.findIndex((adj) => adj.id === action.payload.id);
        if (index !== -1) {
          state.adjustments[index] = action.payload;
        }
      });
  },
});

export default timeAdjustmentSlice.reducer;